import { useState, useContext } from 'react';
import { AppContext } from '.';

export default (): number => {
  const context = useContext(AppContext);
  const [componentIndex] = useState(context.nextComponentIndex);
  return componentIndex;
};
